import { Component } from "react"
import PropTypes from "prop-types"
import cloneDeep from "lodash/cloneDeep"
import EndpointTestAssertions from "partners/components/endpoint_test/assertions"
import EndpointTestCaseMessage from "partners/components/endpoint_test/test_case_message"

export default class EndpointTestCaseItem extends Component {
  constructor(props) {
    super(props)
    this.toggleTestCase = this.props.toggleTestCase.bind(this)
  }

  render() {
    const testCase = cloneDeep(this.props.testCase)
    testCase["endpoint_slug"] = this.props.endpoint.slug
    const status = this.props.testCaseStatus(testCase)
    return (
      <div
        key={`test-case-${testCase.slug}`}
        className={`test-case publish-item ${status} ${
          testCase.isShowing ? "expanded" : "collapsed"
        }`}
      >
        <header onClick={() => this.props.toggleTestCase(testCase)}>
          {testCase.label}
          <span className="test-case-message">{testCase.message}</span>
        </header>
        {testCase.isShowing ? (
          <EndpointTestCaseMessage type="request" message={testCase.request} />
        ) : null}
        {testCase.isShowing ? (
          <EndpointTestCaseMessage
            type="response"
            message={testCase.response}
          />
        ) : null}
        {testCase.isShowing ? (
          <EndpointTestAssertions assertions={testCase.assertions} />
        ) : null}
      </div>
    )
  }
}

EndpointTestCaseItem.propTypes = {
  endpoint: PropTypes.object.isRequired,
  slug: PropTypes.string.isRequired,
  testCase: PropTypes.object.isRequired,
  testCaseStatus: PropTypes.func.isRequired,
  toggleTestCase: PropTypes.func.isRequired,
}
